import axios from "axios";
import urls from "./urls";

const api = axios.create({
    baseURL: urls.whatsappApi.PROD + "/conversation",
});

export const newConversation = async (data) => {
    try {
        const result = await api.post("/", data);
        console.log(result.data);
        return result.data;
    } catch (e) {
        console.log(e);
        return {
            ok: false,
            ...e.response.data,
        };
    }
};

export const checkConversation = async (data) => {
    try {
        const result = await api.post("/check", data);
        console.log(result.data);
        return result.data;
    } catch (e) {
        console.log(e);
        return {
            ok: false,
            ...e.response.data,
        };
    }
};

export const terminateConversation = async (convId) => {
    try {
        const result = await api.post("/terminate", { convId });
        console.log(result.data);
        return result.data;
    } catch (e) {
        console.log(e);
        return {
            ok: false,
            ...e.response.data,
        };
    }
};
